export default {
    modalGenerateImageVariations: {
        imageAIHeader: 'Erstellen Sie ein Bild mithilfe von AI',
        requestFailed: 'Anfrage fehlgeschlagen',
        describeYourImage: 'Beschreiben Sie Ihr Bild',
        numberOfVariations: 'Anzahl der Variationen',
        chooseStyle: 'Wähle deinen Bildstil',
        descriptionPlaceholder: '(eg) Ein Feld aus Senfblumen an einem Sommertag mit Eichenbäumen',
        clear: 'Übersichtlich',
        generate: 'Erzeugen',
        seeAll: 'Alle anzeigen',
        tryAnExample: 'Probiere ein Beispiel aus',
        tryAnother: 'Versuche es nochmal',
    },
};
